import { Field, Form, Formik } from "formik";
import React, { useEffect, useState,useContext } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import * as Yup from "yup";
import "../../../components/customer-information/customer-information.css";
import { useDispatch } from "react-redux";
import AddButton from "../../../components/buttons/button";
import successToast from "../../../components/helper-components/success-toast";
import errorToast from "../../../components/helper-components/error-toast";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/forms/input-field";
import SelectField from "../../../components/forms/select-field";
import {
  roundingMethodoptions,
  roundingRuleoptions,
} from "../../../components/helper-components/data";
import { priceListAction } from "../../../redux/actions/general-action";
import { priceListCreateAction } from "../../../redux/actions/discount-action";
import CheckBox from "../../../components/forms/check-box-field";
import { handleShowErrorToast } from "../../../components/helper-components/helper-function";
import AccessDenied from "../../../components/helper-components/access-denied";
import { DataContext } from "../../../components/layouts/main-layout";
const AddPriceList = () => {
  const dispatch = useDispatch();
  const { permissionFn } = useContext(DataContext);
  const [priceList, setPriceList] = useState([]);
  const [priceListConfig, setPirceListConfig] = useState([]);
  const hasCreateAccess = permissionFn("price_list")?.create === true;
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const billingData = parsed.find((obj) => obj?.price_list_type);
      if (billingData?.price_list_type) {
        setPirceListConfig(billingData.price_list_type);
      }
    }
  }, []);

  useEffect(() => {
    dispatch(priceListAction(onpriceSuccess, onpriceError));
  }, []);
  const onpriceSuccess = (data) => {
    setPriceList(
      data?.data?.map((item) => {
        return { label: item?.price_list_name, value: item?.price_list_id };
      })
    );
  };
  const onpriceError = () => {};

  const initialValues = {
    price_list_name: "",
    default_base_price_list_id: "",
    default_factor: 0,
    margin_factor: 0,
    rounding_method: "no_rounding",
    rounding_rule: "",
    default_price_list: false,
    is_margin_percentage: false,
    pricing_type: "",
  };

  const validationSchema = Yup.object().shape({
  price_list_name: Yup.string()
    .transform(v => (typeof v === "string" ? v.trim() : v))
    .max(255, "Price list name must be less than or equal to 255 characters")
    .required("Price list name is required"),

  default_base_price_list_id: Yup.string().required(
    "Default base price list ID is required"
  ),
  default_factor: Yup.number()
    .required("Discount % is required")
    .max(100, "Discount % cannot exceed 100"),
  margin_factor: Yup.number()
    .required("Margin % is required")
    .max(100, "Margin % cannot exceed 100"),
  rounding_method: Yup.string(),
  rounding_rule: Yup.string(),
});


const onSubmit = async (values, { setSubmitting, validateForm }) => {
  const errs = await validateForm();
  if (Object.keys(errs).length) {
    const firstError = Object.values(errs)[0];
    errorToast(firstError);
    return;
  }

  const data = {
    default_base_price_list: priceList?.find(
      (item) => item?.value === values?.default_base_price_list_id
    )?.label,
    ...values,
    item_batch_mrp: values.pricing_type === "MRP",
    item_batch_purhcase_rate_before_tax: values.pricing_type === "PR",
    item_batch_ptr: values.pricing_type === "PTR",
    item_batch_pts: values.pricing_type === "PTS",
    item_batch_base_price: values.pricing_type === "BP",
  };
  const { pricing_type, submittedButton, ...transformData } = data;
  dispatch(priceListCreateAction(transformData, onSuccess, onError));
  // dispatch(priceListCreateAction(data, onSuccess, onError));
};


  const onSuccess = (data) => {
    navigate("/price-list");
    successToast(data?.message);
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };
  if (!hasCreateAccess) {
    return (
      <InnerLayout backBtn={true} title="Add Price List">
        <AccessDenied message="You don't have permission to create Price List." />
      </InnerLayout>
    );
  }
  return (
    <InnerLayout backBtn={true} bckbutton title="Add Price List ">
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, values, setFieldValue, errors }) => {
          return (
            <Form className="h-full pt-5">
              <div className="flex flex-col justify-between h-full ">
                <div className="w-[99%] px-5 border border-[--button-border-color] rounded-md mx-2 py-2">
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-8 gap-y-6">
                    {/* LEFT COLUMN */}
                    <div className="flex flex-col gap-3 pt-5">
                      <InputField
                        type="text"
                        name="price_list_name"
                        placeholder="Enter name"
                        label="Price Name"
                        isRequired={true}
                      />

                      <SelectField
                        placeholder="Select rounding method"
                        options={roundingMethodoptions}
                        label="Rounding Method"
                        id="rounding_method"
                        name="rounding_method"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                      />

                      <SelectField
                        placeholder="Select rounding rule"
                        options={roundingRuleoptions}
                        label="Rounding Rule"
                        id="rounding_rule"
                        name="rounding_rule"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                      />
                    </div>

                    {/* MIDDLE COLUMN */}
                    <div className="flex flex-col gap-3 border-r border-[--button-border-color] pr-3 pt-5">
                      <SelectField
                        placeholder="Select base price"
                        options={priceList}
                        label="Base Price List"
                        id="default_base_price_list_id"
                        name="default_base_price_list_id"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        isRequired={true}
                      />

                      <InputField
                        isDisabled={values?.is_margin_percentage}
                        max="100"
                        handleChange={(event) => {
                          const value = event?.target?.value;
                          if (parseFloat(value) > 100) {
                            event.preventDefault();
                            errorToast("Discount percentage cannot exceed 100%");
                          }
                        }}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace","Delete","Tab","Escape","Enter",
                            "ArrowLeft","ArrowRight","ArrowUp","ArrowDown",
                            "Home","End","PageUp","PageDown",
                          ];
                          const isNumber = /^[0-9]$/.test(event.key);
                          const isDecimal = event.key === ".";
                          const isAllowedKey = allowedKeys.includes(event.key);

                          if (!isNumber && !isDecimal && !isAllowedKey) {
                            event.preventDefault();
                            errorToast("Only numbers and decimal point are allowed");
                          }
                        }}
                        type="number"
                        name="default_factor"
                        placeholder="Enter discount %"
                        label="Discount Percentage"
                        isRequired={!values?.is_margin_percentage}
                      />

                      <InputField
                        isDisabled={!values?.is_margin_percentage}
                        max="100"
                        handleChange={(event) => {
                          const value = event?.target?.value;
                          if (parseFloat(value) > 100) {
                            event.preventDefault();
                            errorToast("Margin percentage cannot exceed 100%");
                          }
                        }}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace","Delete","Tab","Escape","Enter",
                            "ArrowLeft","ArrowRight","ArrowUp","ArrowDown",
                            "Home","End","PageUp","PageDown",
                          ];
                          const isNumber = /^[0-9]$/.test(event.key);
                          const isDecimal = event.key === ".";
                          const isAllowedKey = allowedKeys.includes(event.key);

                          if (!isNumber && !isDecimal && !isAllowedKey) {
                            event.preventDefault();
                            errorToast("Only numbers and decimal point are allowed");
                          }
                        }}
                        type="number"
                        name="margin_factor"
                        placeholder="Enter margin %"
                        label="Margin Percentage"
                        isRequired={values?.is_margin_percentage}
                      />
                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="flex flex-col gap-6 pt-5">

                      {/* Pricing Type */}
                      <div className="flex flex-col gap-3 text-sm">
                        <label className="fw_600">Pricing Type</label>
                        {priceListConfig.map((cfg) => {
                          if (!cfg?.enabled) return null;
                          const radioValueMap = {
                            item_batch_mrp: "MRP",
                            item_batch_purhcase_rate_before_tax: "PR",
                            item_batch_ptr: "PTR",
                            item_batch_pts: "PTS",
                            item_batch_base_price: "BP",
                          };

                          const radioValue = radioValueMap[cfg?.value];
                          if (!radioValue) return null;

                          return (
                            <label key={cfg.value} className="flex items-center gap-2 cursor-pointer">
                              <Field
                                type="radio"
                                name="pricing_type"
                                value={radioValue}
                                className="hidden peer"
                              />
                              <span className="w-3 h-3 rounded-full border border-gray-400 peer-checked:border-primary peer-checked:bg-primary transition-colors" />
                              <span className="text-sm text-gray-800">{cfg.label}</span>
                            </label>
                          );
                        })}
                      </div>

                      {/* Calculation Mode Toggle */}
                      <div className="flex flex-col gap-2 pt-6 border-t border-[var(--button-border-color)]">
                        <label className="fw_600">Calculation Mode</label>

                        <div className="flex gap-4 items-center">
                          <span
                            className={`${values.is_margin_percentage ? "text-disabled-color" : ""}`}
                          >
                            Discount%
                          </span>

                          <button
                            type="button"
                            role="switch"
                            aria-checked={values.is_margin_percentage}
                            onClick={() =>
                              setFieldValue("is_margin_percentage", !values.is_margin_percentage)
                            }
                            data-state={values.is_margin_percentage ? "checked" : "unchecked"}
                            className={`peer inline-flex h-5 w-12 shrink-0 cursor-pointer items-center rounded-full
                              border-2 border-white shadow-sm transition-colors focus-visible:outline-none
                              focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
                              focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50
                              ${values.is_margin_percentage ? "bg-D5E6Ff" : "bg-D5E6Ff"}`}
                            id="toggleSwitch"
                            aria-label="Toggle Switch"
                            title={
                              values.is_margin_percentage
                                ? "Switch to Discount %"
                                : "Switch to Margin %"
                            }
                          >
                            <span
                              data-state={values.is_margin_percentage ? "checked" : "unchecked"}
                              className={`pointer-events-none block h-5 w-5 rounded-full bg-primary shadow-lg ring-0 transition-transform
                                ${values.is_margin_percentage ? "translate-x-7" : "translate-x-0"}`}
                            />
                          </button>

                          <span
                            className={`${values.is_margin_percentage ? "" : "text-disabled-color"}`}
                          >
                            Margin%
                          </span>
                        </div>
                        <div className="flex items-center">
                          <CheckBox
                            conClass="flex flex-wrap justify-between gap-4 fw_600"
                            onChange={(fieldName, checked) => {
                              if (checked) {
                                const confirmed = window.confirm(
                                  "Do you want to make this as a default price list?"
                                );
                                if (confirmed) {
                                  setFieldValue(fieldName, true);
                                } else {
                                  // Keep the checkbox unchecked if user cancels
                                  setFieldValue(fieldName, false);
                                }
                              } else {
                                setFieldValue(fieldName, false);
                              }
                            }}
                            items={[
                              {
                                label: "Set as default",
                                name: "default_price_list",
                                isRequired: false,
                              },
                            ]}
                          />
                      </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end gap-5 px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={() => {
                      setFieldValue("submittedButton", "draft");
                      if (Object.keys(errors).length > 0) {
                        handleShowErrorToast(errors);
                      }
                    }}
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </InnerLayout>
  );
};

export default AddPriceList;
